module.exports = __webpack_public_path__ + "img/4.af42aea1.png";